import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import ComponentVariableListStandardCategorized from "./standard-categorized/ComponentVariableListStandardCategorized.vue";
import ComponentVariableListStandard from "./standard/ComponentVariableListStandard.vue";
import ComponentVariableListMasonry from "./masonry/ComponentVariableListMasonry.vue";
import ComponentVariableListEmptyContent from "./empty-content/ComponentVariableListEmptyContent.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableList',
    props: {
        componentMutableKey: {},
        type: {},
        hiddenVariableNames: {},
        isMasked: { type: Boolean },
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(ComponentVariableListEmptyContent, { "component-mutable-key": _ctx.componentMutableKey }, null, 8 /* PROPS */, ["component-mutable-key"]),
                (_ctx.type === 'STANDARD')
                    ? (_openBlock(), _createBlock(ComponentVariableListStandard, {
                        key: 0,
                        "component-mutable-key": _ctx.componentMutableKey,
                        "hidden-variable-names": _ctx.hiddenVariableNames,
                        "is-masked": _ctx.isMasked,
                        componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                    }, null, 8 /* PROPS */, ["component-mutable-key", "hidden-variable-names", "is-masked", "componentDrawerRouteConfig"]))
                    : _createCommentVNode("v-if", true),
                (_ctx.type === 'STANDARD_CATEGORIZED')
                    ? (_openBlock(), _createBlock(ComponentVariableListStandardCategorized, {
                        key: 1,
                        "component-mutable-key": _ctx.componentMutableKey,
                        "hidden-variable-names": _ctx.hiddenVariableNames,
                        "is-masked": _ctx.isMasked,
                        componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                    }, null, 8 /* PROPS */, ["component-mutable-key", "hidden-variable-names", "is-masked", "componentDrawerRouteConfig"]))
                    : (_ctx.type === 'MASONRY')
                        ? (_openBlock(), _createBlock(ComponentVariableListMasonry, {
                            key: 2,
                            "component-mutable-key": _ctx.componentMutableKey,
                            componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                        }, null, 8 /* PROPS */, ["component-mutable-key", "componentDrawerRouteConfig"]))
                        : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
